module.exports = __webpack_public_path__ + "img/wpi-logo-min.3e795945.png";